import { get, find, size } from 'lodash-es';
import { fromJS } from 'immutable';
import { statusSalesRouteEnum } from './enum';

/**
 * find index by ID
 * @param {*} param0
 */
export const findIndexById = ({ list, id }) => {
  try {
    if (list) {
      const index = list.findIndex(obj => obj.get('id') === id);
      return index;
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`findIndexById ${e.stack}`);
  }
  return -1;
};

/**
 * find object By Id
 * @param {*} param0
 */
export const findById = ({ list, id }) => {
  try {
    if (list) {
      const object = list.find(obj => obj.get('id') === id);
      return object;
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`findById ${e.stack}`);
  }
  return null;
};

export const findSalesRouteIndexById = ({ list, id }) => findIndexById({ list, id });
export const findSalesRouteById = ({ list, id }) => findById({ list, id }) || fromJS({});
export const checkIsEmpty = value => value === undefined || value === null;

/**
 * get Questionnaire Salesroute By IdQuestionnaire
 * @param {} param0
 */
export const getQuestionnaireSalesrouteByIdQuestionnaire = ({ salesroute, idQuestionnaire }) => {
  try {
    const questionnaireSalesroute = find(get(salesroute, 'questionnaires'), {
      questionnaire: { id: idQuestionnaire },
    });
    return questionnaireSalesroute;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getQuestionnaireSalesrouteByIdQuestionnaire ${e.stack}`);
  }
  return undefined;
};

/**
 * get Quotation Salesroute By RefQuestionnaire
 * @param {*} param0
 */
export const getQuotationSalesrouteByRefQuestionnaire = ({ salesroute, refQuestionnaire }) => {
  try {
    const quotationSalesroute = find(get(salesroute, 'quotations'), {
      questionnaire: { ref: refQuestionnaire },
    });
    return quotationSalesroute;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getQuotationSalesrouteByRefQuestionnaire ${e.stack}`);
  }
  return undefined;
};

/**
 * check if SalesRoute Is Finished
 * @param {*} param0
 */
export const checkSalesRouteIsFinished = ({ salesroute }) => {
  try {
    // TODO check status salesRoute ...
    const isFinishedSalesRoute =
      get(salesroute, 'status') === statusSalesRouteEnum.SUBSCRIBED || size(get(salesroute, 'documents', [])) > 0;
    return isFinishedSalesRoute;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`checkSalesRouteIsFinished ${e.stack}`);
  }
  return false;
};

export const getNameString = partie => {
  let name = '';

  if (partie.is_person) {
    if (partie.first_name) {
      name = `${partie.first_name}`;
    }

    if (partie.name) {
      name = `${name} ${partie.name}`;
    }

    return name;
  }

  return partie.name || name;
};
